import {
    shareTemplateEndpoint,
    updateProductTemplateEndpoint,
    deleteTemplateEndpoint,
    createEquityProductTemplateEndpoint,
    getUserListEndpoint
} from 'src/pages/more/pages/templates/redux/services/endpoints.js';
import axios from 'src/api/Api';

export const shareTemplateService = async (queryParams) => {
    try {
        const response = await axios.post(shareTemplateEndpoint(localStorage.getItem(
            'baseSiteId'
        )),queryParams);
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

export const updateProductTemplateDataService = async (queryParams) => {
    try {
        const response = await axios.put(
            updateProductTemplateEndpoint(),
            queryParams
        );
        return response ? response.data : {};
    }catch (error) {
        return {};
    }
};
    
export const deleteTemplateService = async (queryParams) => {
    try {
        const response = await axios.delete(deleteTemplateEndpoint(queryParams));
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

export const createEquityProductTemplateDataService = async (queryParams) => {
    const response = await axios.post(
        createEquityProductTemplateEndpoint(localStorage.getItem('baseSiteId')),
        queryParams,
    );
    return response ? response.data : {};
};

export const getUserListService = async (params) => {
    try {
        const response = await axios.get(getUserListEndpoint(params));
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

